export const FAQs = [
  {
    question: "Who are the vendors you use?",
    answer:
      "We have a pre-vetted vendor network of over 3000 service providers. We only work with licensed vendors, who have to go through a rigorous vetting process."
  },
  {
    question: "What is your vendor vetting process?",
    answer:
      "We evaluate vendors rigorously — across multiple variables —  licensure, jobs completed, technical skill and more."
  },
  {
    question: "Will you be in-person at my home?",
    answer:
      "Our local expert will come on-site and in-person at your home. For individual projects, we will send licensed, pre-vetted vendors to your home to complete projects in a timely manner."
  },
  {
    question: "How often will someone come to my home?",
    answer:
      "Our customers have a monthly check-in with their dedicated Home Coordinator, who will dispatch experts and vendors as needed. How often someone comes to your home depends on your specific needs, timeline and more."
  }
];
